import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {

  @Input() isOpen = false;
  @Input() title = 'title';

  constructor() { }

  ngOnInit() {
  }

  onBtnBlick() {
    console.log(this.isOpen);
    this.isOpen = !this.isOpen;
  }
}
